import React, { useEffect, useState } from "react";
import StoreAPI from "../../api/StoreApi";
import { formatDate } from "../../helper/Helper";
import { Link } from "react-router-dom";

function Sitemap() {
  const [slugs, setSlugs] = useState([]);

  useEffect(() => {
    fetchSiteMap();
  }, []);

  const fetchSiteMap = async () => {
    try {
      const res = await StoreAPI.getSitemap();

      if (res.code === 200) {
        setSlugs(res.data);
      }
    } catch (err) {}
  };

  return (
    <>
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Sitemap</h4>
              <h6>View all pages displayed across your store.</h6>
            </div>
          </div>
          <div className="page-btn">
            <Link to="/sitemap/add-new" className="btn btn-primary">
              <i className="ti ti-circle-plus me-1" />
              Add Page SEO
            </Link>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h4>Slugs</h4>
          </div>
          <div className="card-body">
            {slugs &&
              slugs.map((group, groupIndex) => (
                <div key={groupIndex}>
                  <h5 className="fw-bold">{group.title}</h5>
                  <ol className="list-group sortable-list mb-4">
                    {group.slug.map((item, index) => (
                      <li key={index} className="list-group-item">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center">
                            <div className="ms-2">
                              <h6 className="fw-bold mb-1">
                                <a
                                  href={`${localStorage.getItem(
                                    "selectedStoreSlug",
                                  )}${item.slug}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {item.title}
                                </a>
                              </h6>
                              <p
                                className="fs-13"
                                style={{ fontWeight: "400" }}
                              >
                                Last Updated - {formatDate(item.updatedAt)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ol>
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Sitemap;
